var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "menu--section-st_patricks_day_drinks" }, [
    _vm.menu.menu_property === "wv"
      ? _c("div", [_vm._m(0)])
      : _c("div", [_vm._m(1)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("img", {
        attrs: {
          alt: "St. Patrick's Day Emerald Crush Cocktail",
          src: "/library/images/menu/st-patricks-day-drinks-wv.jpg",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("img", {
        attrs: {
          alt: "St. Patrick's Day Emerald Crush Cocktail",
          src: "/library/images/menu/st-patricks-day-drinks-reno.jpg",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }